var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { GAME_UPDATE_STAGES, GAME_SET_CURRENT_STAGE_PAUSE } from 'components/constants';
import { getActiveStage } from 'helpers/stageUtilities';
var stageUpdateInterval = null;
export var activeStageTimerMiddleware = function (_a) {
    var getState = _a.getState, dispatch = _a.dispatch;
    return function (next) { return function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var state, game_1, activeStage, modifiedActiveStage_1;
        return __generator(this, function (_a) {
            next(action);
            if (action.type === GAME_UPDATE_STAGES || action.type === GAME_SET_CURRENT_STAGE_PAUSE) {
                clearInterval(stageUpdateInterval);
                state = getState();
                game_1 = state.game;
                activeStage = game_1 && game_1.stages ? getActiveStage(game_1.stages) : null;
                if (activeStage) {
                    modifiedActiveStage_1 = Object.assign({}, activeStage);
                    stageUpdateInterval = setInterval(function () {
                        modifiedActiveStage_1.spentTime += 5;
                        var stageIndex = game_1.stages.findIndex(function (stage) { return stage.id === modifiedActiveStage_1.id; });
                        var updatedStages = __spreadArray([], game_1.stages, true);
                        updatedStages[stageIndex] = modifiedActiveStage_1;
                        dispatch({ type: GAME_UPDATE_STAGES, payload: updatedStages });
                    }, 5000);
                }
            }
            return [2 /*return*/];
        });
    }); }; };
};
